export enum Enum {}
export enum UserList {
  USER_LIST = "user list",
}
export enum Categories {
  CATEGORY_GROUPID = 'categoryGroupId',
  PARENT_CATEGORY_GROUPID = 'parentcategoryGroupId',
  CATEGORY_ID = 'categoryId',

}

export enum ActiveTab {
  IN_STOCK = "InStock",
  ALLOCATION = "Allocations",
  CONSIGNMENT = "Consignment",
  PENDING = "Pending",
  QUARANTINE = "Quarantine",
  SOLD = "Sold",
  OFFERS = "Offers",
  OEMEXCESS = "OEMExcess",
  VENDORPARTS = "VendorParts",
  REQUIREMENT = "Requirements",
  QUOTES = "Quotes",
  SALESORDERS = "SalesOrders",
  PURCHASEORDERS = "PurchaseOrders",
  INVOICES = "Invoices",
  WORK_ORDER = "WorkOrders",
  RMA = "RMA",
  RTV = "RTV",
  NCM = "NCM",
  INSPECTION = "InspectionReports",
  APPROVED = "Approved",
  AVAILABLE = "Available",
  POTENTIAL = "Potential",
  REVIEW = "Review",
  SEND_RFQS = "Sent RFQs",

}

export enum PopUpTitles {
  MARK_AS_ACTIVE = "Mark as active",
  MARK_AS_INACTIVE = "Mark as inactive",
  RESET_PASSWORD = "Reset Password",
  RESET = "Reset",
  ADDRESS = "Address",
  CONTACT = 'Contact',
  ACTIVITY = 'Activity',
  PASSWORD_CHANGED = "Password Changed",
  APPROVE_DELETION = "Approve Deletion",
  DELETE = "Delete",
  SAVECHANGES = "Save changes",
  GRANTPERMISSION = "Grant all permissions",
  TAKEPERMISSION = "Take all permissions",
  UNSAVECHANGES = "Unsaved changes",
  FAVOURITE_DOCKS = "Remove Favorite",
  REPLACE_PRIMARY_CONTACT = "Replace current primary contact",
  POPUP_VALUE = "Error Message!",
  DELETE_TEMPLATEID = "Delete  ",
  EDIT_QUICKNOTES = "Edit Notes",
  ARCHIVED_COMPANIES = "Archive Company",
  UNABLE_ARCHIVED_COMPANIES  = "Unable to Archive",
  UNARCHIVED_COMPANIES = "Unarchive Company",
  TRANSFER = "Transfer",
  UPLOAD_DOCUMENT = 'Upload Document(s)' ,
  ADD =  "Add",
  EDIT = "Edit",
  RESTORE = "Restore",
  TERMS = 'Terms',
  COMMENT = 'Comment',
  DELETE_CATEGORY = 'Delete Category',
  INVENTORY_CATEGORIES   = "Inventory Categories",
  VENDOR_PART_ACTIVE = 'Make Vendor Part Active',
  EXPIRE_VENDOR_PART = 'Expire Vendor Part',
  ERROR = "Error!",
  LINE_ACTIVE = 'Make Line Active',
  EXPIRE_LINE = 'Expire Line',
  UNLINK = 'Unlink',
  PLACEONHOLD = 'Place Inventory Line on Hold',
  UNABLE_TO_DELETE = 'Unable to Delete',
  UNLINK_MANUFACTURER = 'Unlink Manufactures',
  COMMON = 'Common',
  CANNOT_MARED_READY = 'Cannot be Marked as Ready',
  MARK_NO_BID = 'Mark as No Bid',
  REMOVE_VENDOR_FROM_RFQ_LIST = 'Remove Vendor from RFQ List',
  ADD_VENDOR_TO_RFQ_LIST = 'Add Vendor to RFQ List',
  MARK_VENDOR_AS_NO_BID = 'Mark Vendor as No Bid',
  MARK_AS_PART_NOT_AVAILABLE = 'Mark as Part N/A',
  REMOVE_OFFER_APPROVAL = 'Remove Offer Approval',
  OFFER_EXPIRES_SOON = 'Offer Expires Soon',
  CONFIRM_QUANTITY_TO_PURCHASE = 'Confirm Quantity to Purchase',
  CONFIRM_QUICK_SOURCING = 'Confirm Quick Sourcing',
  MULTIPLE_CUSTOMER_SELECTED = 'Multiple Customers Selected',
  ADD_ALTERNATIVE_PART = 'Add Alternative Part',
  ADD_OFFER = 'Add Offer',
  RFQ_ALREADY_SENT = 'RFQ already sent to vendor',

  // admin look-up-tables Multi - Level List PopupTitles 
  ADD_WAREHOUSE = 'Add Warehouse',
  EDIT_WAREHOUSE = "Edit Warehouse",
  ADD_SHIPPING_PROVIDER = "Add Shipping Provider",
  EDIT_SHIPPING_PROVIDERR = "Edit Shipping Provider",
  ADD_BILLING_TERMS = "Add Billing Term",
  EDIT_BILLING_TERMS = "Edit Billing Term",
  ADD_NCM_CODE = "Add NCM Code",
  EDIT_NCM_CODE = "Edit NCM Code",
  ADD_CURRENCY = "Add Currency",
  EDIT_CURRENCY = "Edit Currency",
  ADD_TAG = "Add Tag",
  EDIT_TAG = "Edit Tag",
  ADD_VALUE = "Add Value",
  EDIT_VALUE = "Edit Value",
  ADD_SALE_COMMISSION = "Add Sale Commission",
  EDIT_SALE_COMMISSION = "Edit Sale Commission",
  ADD_PURCHASE_COMMISSION = "Add Purchase Commission",
  EDIT_PURCHASE_COMMISSION = "Edit Purchase Commission",
  EXPIRE_OFFER = "Expire Offer",
  COMPANY_UNAVAILABLE = "Company Unavailble",
  REMOVE_APPROVAL = "Remove Approval",
  EXTEND_EXPIRATION_DATE = "Extend Expiration Date",
  REMOVE_RECORD = 'Remove Record',
  UNMAPPED_HEADERS ='Unmapped Headers'
}

export enum Button {
  TEMPLATE_SETTING = 'Template Settings',
  CANCEL = "Cancel",
  DELETE = "Delete",
  CONFIRM = "Confirm",
  EDIT = 'Edit',
  OKAY = "Okay",
  NO = "No",
  OK = "OK",
  YES = "Yes",
  SAVE = "Save",
  RETRY = "Retry",
  PREVIOUS ='Previous',
  NEXT = 'Next',
  UPDATE = 'Update',
  ADD_COMPANY = 'Add Company',
  ADD_ADDRESS =  'Add Address',
  UPLOAD_DOCUMENT = 'Upload Document',
  UPLOAD = 'Upload',
  UPDATEANDADDNEW = 'Update and Add New',
  SAVEANDADDNEW = 'Save and Add New',
  APPLYCHANGES ='Apply Changes',
  IMPORT = 'Import',
  ASSIGN = 'Assign',
  ADDTASK ='Add Activity',
  SENDEMAIL ='Send Email',
  ARCHIVE = 'Archive',
  RESTORE ='Restore',
  APPROVEDELETION ='Approve Deletion',
  FILTERS = 'Filters',
  ADDCONTACT = 'Add Contact',
  APPLY = 'Apply',
  ASSIGNCOMMISSION = 'Assign Commission',
  ADDUSER = 'Add User',
  SAVECHANGES = 'Save Changes',
  ADDROLE =  'Add Role',
  UPDATEROLE = 'Update Role' ,
  COMPLETEIMPORT = 'Complete Import' ,
  ADDTOQUOTE =  'Add to Quote',
  SENDTOSOURCING =  'Send to Sourcing',
  ADDOFFER ='Add Offer',
  ADDMAILINGLIST ='Add to Mailing List',
  NEW ='New',
  CLONE ='Clone',
  TRANSFER = 'Transfer',
  EDIT_LINE = 'Edit Line',
  DISCARD = 'Discard',
  ADD_CONSIGNMENT  = 'Add Consignment',
  CREATE_PURCHASE_ORDER = 'Create PO',
  RETURN_TO_VENDOR = 'Return to Vendor ',
  WORK_ORDER_REQUEST = 'Work Order Request',
  BACK_TO_STOCK = 'Back to Stock',
  INCLUDE_ALTERNATIVE  = 'Include Alternatives ',
  SHOW_EXCLUDED = 'Show Excluded (3)',
  ADD = 'Add',
  ADD_REFERENCE = "Add Reference ",
  DATE_SORT = "Date Sort",
  SNOOZE    = "Snooze",
  MARK_COMPLETE = "Mark Complete",
  RESET_PASSWORD = 'Reset Password',
  KEEP_ACTIVITY ='Keep Activity',
  MANAGE_MFRS  =  "Manage Mfrs",
  ADD_MANUFACTURER =    "Add Manufacturer",
  UNARCHIVE = 'Unarchive',
  EDIT_COMPANY = "Edit Company",
  EDIT_VENDOR = 'Edit Vendor',
  ADD_REQUIRMENT = "Add Requirement",
  ADD_OFFER    = "Add Offer",
  ADD_QUOTE        = "Add Quote",
  ADD_SALES_ORDER =   "Add Sales Order",
  ADD_PURCHASE_ORDER = "Add Purchase Order",
  SEND_TO_QBO =   "Send to QBO",
  CLOSE_TAB = 'Close Tab',
  CLOSE = 'Close',
  REMOVEHOLD = 'Remove Hold',
  REMOVE = 'Remove',
  PLACEHOLD = 'Place Hold',
  NEW_IMPORT = 'New Import',
  SAVE_AS_DRAFT = 'Save as Draft',
  EDIT_REQUIRMENT = "Edit Requirement",
  ADD_VENDOR = "Add Vendor",
  MARK_READY_TO_QUOTE = "Mark Ready to Quote",
  REMOVE_READY_STATUS = "Remove Ready Status",
  MARK_NO_BID = "Mark No Bid",
  SEND = 'Send',
  REFRESH = 'Refresh',
  DISCONNECT = 'Disconnect',
  SUBMIT_OFFER = 'Submit Offer',
  CONTINUE = 'Continue',
  CLONE_REQUIREMENT = 'Clone Requirement',
  REMOVE_FROM_BATCH = 'Remove From Batch',
  ADD_TO_SOURCING_BATCH = 'Add to Sourcing Batch',
  CREATE_SOURCING_BATCH = 'Create Sourcing Batch',
  ADD_VENDOR_TO_ALL_REQUIREMENTS = 'Add Vendor to All Requirements',
}

export enum FooterTitle {
  USER_MANAGEMENT = "User Management",
  USER_ROLE = "User Role",
  COMPANY = "Companies",
  LOOKUP = "Masters",
  LEADS = "Leads",
  PROSPECTS = 'Prospects',
  TASKS = "Tasks",
  ACTIVITY_MANAGER = "Activity Manager", 
  CUSTOMERS = 'Customers',
  CONTACTS = "Contacts",
  VENDORS = 'Vendor List',
  VENDOR_CONTACT = 'Vendor Contact',
  CONTACT_RECYCLEBIN = 'Contact Recycle Bin',
  COMPANY_RECYCLEBIN = 'Company Recycle Bin',
  CROSSWALK = 'Code Crosswalk',
  REQUIREMENTS = "Requirements",
  PARTLIST = "Parts List",
  PARTLISTINFO = "Parts List",
  INVENTORYCATEGORIES  =   "Inventory Categories",
  VENDOR_PART_LIBRARY = "Vendor Part Library",
  OEM_EXCESS_MANAGER = "OEM Excess Manager",
  OUTLOOK = "Outlook Dashboard",
  SOURCING = "Sourcing",
}

export enum Url {
  USER_MANAGEMENT_URL = "./assets/SVGIcons/user-management.svg",
  USER_ROLE_URL = "./assets/SVGIcons/user-role.svg",
  COMPANY_URL = "./assets/SVGIcons/Company.svg",
  LOOKUP_URL = "./assets/SVGIcons/lookup-tables.svg",
  PROSPECTS = "./assets/SVGIcons/crm/newBreafCase.svg",
  LEADS = "./assets/SVGIcons/crm/phoneicon.svg",
  CUSTOMERS = "./assets/SVGIcons/crm/customers.svg",
 CONTACTS = "./assets/SVGIcons/crm/contact.svg",
 TASKS = "./assets/SVGIcons/crm/task.svg",
 ACTIVITY_MANAGER = "./assets/SVGIcons/crm/task.svg",
 CROSSWALK = "./assets/SVGIcons/crm/contact.svg",
 REQUIREMENTS = "./assets/SVGIcons/sales/requirements-icon.svg",
 PARTLIST = "./assets/SVGIcons/Company.svg",
 INVENTORYCATEGORIES = "./assets/SVGIcons/crm/contact.svg",
 VENDOR_PART_LIBRARY = "./assets/SVGIcons/Company.svg",
 OEM_EXCESS_MANAGER = "./assets/SVGIcons/Company.svg",
 OUTLOOK = "./assets/SVGIcons/outlook.svg",
}

export enum Path {
  USER_MANAGEMENT_PATH = "admin/user-management",
  USER_ROLE_PATH = "admin/user-management/rolesAndPermissions",
  COMPANY_PATH = "crm/companies",
  LOOKUP_PATH = "admin/look-up-tables",
  PROSPECTS_PATH = "crm/prospects",
  LEADS_PATH = "crm/leads",
  CUSTOMERS_PATH = 'crm/customers',
  CONTACTS_PATH = "crm/contacts",
  TASKS_PATH = 'crm/taks',
  ACTIVITY_MANAGER_PATH='crm/activityManager',
  COMPANY_INFO_PATH = 'crm/companies/company-info',
  IMPORT_COMPANIES = 'crm/companies/import-companies',
  IMPORT_VENDORS = 'procurement/vendor-list/import-vendors',
  IMPORT_BOM = 'sales/requirements/import-bom',
  VENDOR_LIST = 'procurement/vendor-list',
  VENDOR_CONTACT = 'procurement/vendor-contact',
  COMPANY_RECYCLEBIN = 'admin/company-recycle-bin',
  CONTACT_RECYCLEBIN = 'admin/contact-recycle-bin',
  CROSSWALK = 'admin/code-crosswalk',
  IMPORT_CROSSWALK = 'admin/code-crosswalk/import',
  REQUIREMENTS = 'sales/requirements',
  PARTLIST = 'partInventory/parts-list',
  PARTLISTINFO = 'partInventory/parts-list/list-info',
  INVENTORY_CATEGORIES = 'admin/inventory-categories',
  IMPORT = 'partInventory/parts-list/import/',
  VENDOR_PART_LIBRARY = 'partInventory/vendor-parts-library',
  OEM_EXCESS_MANAGER = "partInventory/oem-excess",
  OUTLOOK_PATH = "crm/outlook/outlook-dashboard",
  SOURCING = 'procurement/sourcing'
}
export enum RoutePath {
  COMPANY_ROUTEPATH = "/crm/companies",
  LEAD_ROUTEPATH = '/crm/leads',
  PROSPECT_ROUTEPATH ='/crm/prospects',
  CUSTOMER_ROUTEPATH ='/crm/customers',
  IMPORTVENDOR_ROUTEPATH = '/procurement/vendor-list/import-vendors',
  VENDORLIST_ROUTEPATH = '/procurement/vendor-list',
  IMPORTCOMPANY_ROUTEPATH =  '/crm/companies/import-companies',
  IMPORTBOM_ROUTEPATH =  '/sales/requirements/import-bom',
  CODECROSSWALK_ROUTEPATH = '/admin/code-crosswalk',
  REQUIREMENT_ROUTEPATH ='/sales/requirements',
  CONTACT_ROUTEPATH ='/crm/contacts',
  VENDORCONTACT_ROUTEPATH = '/procurement/vendor-contact',
  PARTLIST_ROUTEPATH = '/partInventory/parts-list',
  PARTLISTINFO_ROUTEPATH = '/partInventory/parts-list/list-info',
  PROCUREMENT_VENDOR_CONTACT_ROUTEPATH = '/procurement/vendor-contact',
  CONTACT_RECYLCLE_BIN_ROUTEPATH = '/admin/contact-recycle-bin',
  COMPANY_RECYCLE_BIN_ROUTEPATH ='/admin/company-recycle-bin',
  PROCUREMENT_VENDOR_LIST_ROUTEPATH = '/procurement/vendor-list',
  ARCHIVED_COMPANIES_ROUTEPATH = '/crm/archivedCompanies',
  VENDOR_PARTS_LIBRARY = '/partInventory/vendor-parts-library',
  VENDOR_PARTS_LIBRARY_DETAILS = '/partInventory/vendor-parts-library/library-info',
  OEM_EXCESS = '/partInventory/oem-excess',
  CRM_COMPANIES_COMPANY_INFO = '/crm/companies/company-info/',
  PROCUREMENT_VENDOR_INFO   = '/procurement/vendor-info/',
  PARTLIST_IMPORT_ROUTEPATH =  '/partInventory/parts-list/import',
  VPLINFO_ROUTEPATH ='/partInventory/vendor-parts-library/library-info/',
  OEMMANAGERINFO_ROUTEPATH ='/partInventory/oem-excess/excess-info/',
  REQUIREMENTINFO_ROUTEPATH='/sales/requirements/req-info/',
  PROCUREMENT_SOURCIN_ROUTEPATH ='/procurement/sourcing',
  PARTLIST_IMPORT_INVENTORY_ROUTEPATH ='/partInventory/parts-list/import/Inventory',
  PARTLIST_IMPORT_PARTS_ROUTEPATH ='/partInventory/parts-list/import/Part',
  PARTLIST_IMPORT_OEMEXCESS_ROUTEPATH ='/partInventory/parts-list/import/OEMExcess',
  PARTLIST_IMPORT_VENDORPARTS_ROUTEPATH ='/partInventory/parts-list/import/VendorParts',  
  PARTLIST_IMPORT_CONSIGNMENT_ROUTEPATH ='/partInventory/parts-list/import/Consignment',  

}
export enum CurrentTab {
  COMPANY_TAB = 'companies',
  LEAD_TAB = '/crm/leads',
  PROSPECT_TAB ='/crm/prospects',
  CUSTOMER_TAB ='/crm/customers',
  IMPORTVENDOR_TAB = '/procurement/vendor-list/import-vendors',
  VENDORLIST_TAB = 'vendor-list',
  CODECROSSWALK_TAB ='code-crosswalk',
  IMPORTCOMPANY_TAB =  '/crm/companies/import-companies',
  CONTACT_TAB = 'contacts',
  VENDORCONTACT_TAB ='vendor-contact',
  CONTACT_RECYCLE_BIN_TAB = 'contact-recycle-bin',
  COMPANY_RECYCLE_BIN_TAB = 'company-recycle-bin',
  REQUIREMENTS_TAB = 'requirements',
  ARCHIVED_COMPANIES_TAB = 'archivedCompanies',
  ADMIN_COMPANY_RECYCLEBIN_TAB = '/admin/company-recycle-bin',
  PROCUREMENT_VENDOR_CONTACT = '/procurement/vendor-contact',
  PROCUREMENT_VENDOR_LIST = '/procurement/vendor-list',
  PARTLIST = 'parts-list',
  SOURCING = 'sourcing',
  IMPORT_BOM_TAB = 'import-bom'
}


export enum EnfoRoutePath {
  CRM_COMPANIES_COMPANY_INFO = '/crm/companies/company-info/',
  PROCUREMENT_VENDOR_INFO   = '/procurement/vendor-info/',
}


export enum LabelsName{
  SALESPERSON               = "Salesperson",
  ALT_SALESPERSON           = "Alt Salesperson",
  BUYERS_REP                = "Buyer’s Rep",
  LAST_CONTACTED            = "Date Last Contacted",
  DATE_RANGE                = "Date Range",
  SCOPE                     = "Scope",
  COUNTRY                   = "Country",
  STATE                     = "State",
  TIME_ZONE                 = "Time Zone",
  INDUSTRY                  = "Industry",
  STAGE_STATUS              = "Stage Status",
  SIC_CODE                  = "SIC Code",
  NAICS_CODE                = "NAICS Code",
  LEAD_SCORE                = "Lead Score",
  PROSPECT_SCORE            = "Prospect Score",
  CUSTOMER_SCORE            = "Customer",
  CERTIFICATIONS            = "Certifications",
  MANUFACTURER              = "Manufacturer",
  SALE_COMMISSION_ROLE      = "Sales Commission Role",
  PURCHASE_COMMISSION_ROLE  = "Purchase Commission Role",
  SALE_STAGE                = "Sale Stage",
  VENDOR                    = "Vendor",
  VENDOR_CONTACT            = "Vendor Contact",
  CATEGORY_GROUP            = "Category Group",
  PARENT_CATEGORY           = "Parent Category",
  CATEGORY                  = "Category",
  SUB_CATEGORY              = "Sub Category",
  REQUIREMENT_DATE          = "Requirement Date",
  STAGE                     = "Stage",
  ALTERNATE_SALESPERSON     = "Alternate Salesperson",
  RATING                    = 'rating',
  ACTIVE                    = 'Active',
  TIMEZONE                  = 'Timezone',
  TAGS                      = 'Tags',
  CURRENCY                  = 'Currency',
  SIC                       = 'SIC',
  REQUIREMENT_SOURCE        = 'Requirement Source',
  PRIORITY                  = 'Priority',
  MPN                       = 'MPN',
  MFR                       = 'MFR',
  DATE_CODE_YEAR            = 'Date Code Year',
  DATE_CODE_WEEK            = 'Date Code Week',
  ROHS                      = 'RoHS',
  CONDITION                 = 'Condition',
  ITEM_PACKAGE              = 'Item Package',
  COO                       = 'COO',
  TESTING                   = 'Testing',
  OPPORTUNITY_TYPE          = 'Opportunity Type',
  PROJECT_APPROVED          = 'Project Approved',
  PART_STATUS               = 'Part Status',
  OPPORTUNITY_BUY_TYPE      = 'Opportunity Buy Type',
}
export enum LablesNames
{
  RATING                    = 'rating',
  ACTIVE                    = 'Active',
  INACTIVE                  = 'InActive',
  ARCHIVED                  = "archived",
  AVL                       = 'AVL',
  NAVL                      ='NAVL',
  EXCLUDEDFROM_VENDOR_LIST  ="excludedFromVendorlist",
  BUYERREP                 = "Buyer's Rep",
  INDUSTRY                  = "Industry",
  MANUFACTURER              = "ManufacturerList",
  INTEND_TO_BUY             = "IntendToBuy",
  LEAD                      = 'Lead',
  NAICS_CODE                = "NAICS Code",
  SCOPE                     = "Scope",
  SALESPERSON               = "Salesperson",
  COUNTRY                   = "Country",
  ALT_SALESPERSON           = "Alt Salesperson",
  TIMEZONE_LIST             ="Time Zone",
  SIC_CODE                  = "SIC Code",
  STAGE_STATUS              ="Stage Status",
  STATE                     = 'State',
  TAGS                      = 'Tags',
//  CLASS                     = 'Class',
CLASS                       = 'Type',
VENDOR_TYPE               ='Vendor Type',
CONTACTEDDATE             ='Contacted Date',
// VENDOR_TYPE               ='VendorTypes',
CREATE = 'Create',
PARTLIST_TAG = 'Tags',
CATEGORY_GROUP            = "Category Group",
PARENT_CATEGORY           = "Parent Category",
CATEGORY                  = "Inventory Category",
SUB_CATEGORY              ="Sub-Category",
PARTSTATUS                = "Part Status", 
LABEL_CATEGORY_GROUP       = "CategoryGroup",
LABEL_PARENT_CATEGORY      = "ParentCategory",
LABEL_CATEGORY             = "InventoryCategory",
LABEL_SUB_CATEGORY         ="SubCategory",
VPL_VENDOR                 ="VendorName",
VPL_VENDOR_CONTACT         ="VendorContact",
OEMEXCESS_COMPANY          ="CompanyName",
OEMEXCESS_COMPANY_CONTACT   ="Contact",
DATERANGE                   = 'DateRange',
OPPORTUNITY_TYPE             = 'OpportunityType',
REQUIREMENT_STATUS           = 'Requirement Status',
OPPORTUNITY_BUY_TYPE          = 'OpportunityBuyTypes',
PRIORITY                      = 'Priority',
REQUIREMENT_DATE              = "Requirement Date",
CLOSE_PROBABILITY             = "Close Probability"
}

export enum TabNames
{
  COMPANIES           = 'companies',
  LEADS               = 'leads',
  CUSTOMERS           = 'customers',
  PROSPECTS           = 'prospects',
  CONTACTS            = 'contacts',
  VENDOR_LIST         = 'vendor-list',
  VENDOR_CONTACT      = 'vendor-contact',
  COMPANY_RECYCLEBIN  ='company-recycle-bin',
  CONTACT_RECYCLEBIN  ='contact-recycle-bin',
  IMPORT_COMPANIES    ='import-companies',
  REQUIREMENTS        = 'requirements',
  ARCHIVEDCOMPANIES   = 'archivedCompanies',
  IMPORT_CODECROSSWALK='import',
  CODECROSSWALK       = 'code-crosswalk',
  CODECROSSWALKPOPUP  = 'Code Crosswalk',
  PARTLIST            = 'parts-list',
  INSTOCK             = "In Stock",
  PENDING              = "Pending",
  VENDOR_PART_LIBRAY   = 'vendor-parts-library',
  OEM_EXCESS_MANAGER   = 'oem-excess',
  SOURCING   = 'sourcing',
  IMPORT_VENDORS   = 'import-vendors',
  OUTLOOK = 'outlook-dashboard',

  COMPANIES_FILTERS = 'COMPANIES_FILTERS',
  CONTACTS_FILTERS = 'CONTACTS_FILTERS',
  CUSTOMERS_FILTERS = 'CUSTOMERS_FILTERS',
  LEADS_FILTERS = 'LEADS_FILTERS',
  PROSPECTS_FILTERS = 'PROSPECTS_FILTERS',
  VENDORLIST_FILTERS = 'VENDORLIST_FILTERS',
  VENDORCONTACT_FILTERS = 'VENDORCONTACT_FILTERS',
  PARTLIST_FILTERS = 'PARTLIST_FILTERS',
  REQUIREMENTS_FILTERS = 'REQUIREMENTS_FILTERS',
  VENDORPARTLIBRAY_FILTERS = 'VENDORPARTLIBRAYLIST_FILTERS',
  OEMEXCESSMANAGER_FILTERS = 'OEMEXCESSMANAGER_FILTERS',
}
export enum DisplayName
{
  COMPANY             = 'Company',
  VENDOR_NAME         = 'Vendor Name',
  FULL_NAME           = 'Full Name',
  VENDORCONTACT_NAME  = 'Contact Name',
  CERTIFICATION_NAME  = 'Certification Name',
  MESSAGE             = 'Message',
  FILE_NAME           = 'File Name',
  CONTACT_NAME        = 'Contact Name',
  VENDORNAME          = 'vendorName',
  CLASS               = 'Class',
  WEBSITE             = 'Website',
  FAX                 = 'Fax',
  RATING              = 'Rating',
  STAGE               = 'Stage',
  ACCOUNT_CLASS       ='Account Class',
  TYPE                = 'Type',
  PHONE               = 'Phone',
  DATECONTACTED       = 'Date Contacted',
  REVENUE             = 'Revenue',
  QUICKNOTE           = 'Quick Note',
  QUICKNOTES           = 'Quick Notes',
  Active              = 'Active',
  REQUIREMENT         = 'Req No',
  VENDORTYPE          = 'Vendor Type',
  AVL                 = 'AVL',
  LEADSCORE           = 'Lead Score',
  INTENTTOBUY         = 'Intent to Buy',
  // CONTACTNAME         = 'Contact Name',
  COMPANYRATING       = 'Company Rating',
  DEPARTMENT          = 'Department',
  LOCATION            = 'Location',
  TIMEZONE            = 'Time Zone',
  TITLE               = 'Title',
  GENDER               = 'Gender',
  COMPANYNAME         = ' Company',
  OFFICENUMBER        = 'Main Office Number',
  DIRECTNUMBER        = 'Direct Number',
  MOBILENUMBER        = 'Mobile Number',
  EMAILADDRESS        = 'Email Address',
  DONOTCALL           = 'Do Not Call',
  DONOTEMAIL          = 'Do Not Email',
  LASTCONTACT         = 'Last Contact',
  NEXTTASKDUEDATE     = 'Next Task Due Date',
  SALEPERSON          = 'Salesperson',
  ALTERNATESALEPERSON = 'Alternate Salesperson',
  REQDATE             = 'Req Date',
  BUYTARGET           = 'Buy Target',
  TARGETPRICE         = 'Target Price',
  MPN                 =  'MPN',
  REFERENCE_DOCUMENT  = 'Reference Documents',
  PARTNUMBER          = 'Part Number',
  ALLOCATED_QTY       = 'Allocated Qty',
  CONSIGNED_QTY       = 'Consigned Qty',
  STATUS              = 'Status',
  ACTIONS              = 'Actions',
  MFR = 'MFR',
  CONSIGNMENT = 'Consignment',
  OFFER = 'Offers',
  ROHS = 'RoHS',
  VENDOR = 'Vendor',
  DATECODE = 'Date Code',
  LOTCODE = 'Lot Code',
  CONSIGNOR = 'Consignor',
  QTY = 'Qty',
  DATEOFFERED = 'Date Offered',
  LISTDATE = 'List Date',
  CUSTOMERCONTACT = 'Customer Contact',
  CUSTOMER = 'Customer',
  EXPIRATIONDATE = 'Expiration Date',
  VENDORCONTACT = 'Vendor Contact',
  PARTSTATUS = 'Part Status',
  TAG = 'Tags',
  STDPACKAGING = 'Standard Pkg',
  MANUFACTURER = 'Manufacturer',
  CONTACT = 'Contact',
  WORKORDERID = 'Work Order ID',
  STATUSID = 'Status ID',
  COMPNAME ='Company Name',
  EVENT = 'Event',
  ACTION = 'Action',
  BY = 'By',
  CATEGORY = 'Category',
  ACTIVE = 'Active',
  CUSTOMERTARGET = 'Cust. Target',
  PRIORITY = 'Priority',
  DATE_OFFERED = 'Date Offered',
  REQ_NO = 'Req No',
  SB_NO = 'SB No',
  APPROVED = "Approved",
  LINE_STATUS = "Line Status",
  INCLUDE_IN_RFQ = "Include in RFQ",
  RESULT = "Result",
  READY_TO_QUOTE = "Ready to Quote",
  NO_BID = "No Bid",
}
export enum PDFDisplayName
{
  COMPANY             = 'Company',
  RATING              = 'Rating',
  STAGE               = 'Stage',
  TYPE                = 'Type',
  PHONE               = 'Phone',
  SALEPERSON          = 'Salesperson',
  Active              = 'Active',
  DATECONTACTED       = 'Date Contacted',
  REVENUE             = 'Revenue',
  ALTERNATESALEPERSON = 'Alternate Salesperson',
  QUICKNOTE           = 'Quick Note',
  LEADSCORE           = 'Lead Score',
  INTENTTOBUY         = 'Intent to Buy',


  // VENDOR_NAME         = 'Vendor Name',
  // FULL_NAME           = 'Full Name',
  // VENDORCONTACT_NAME  = 'Contact Name',
  // CERTIFICATION_NAME  = 'Certification Name',
  // MESSAGE             = 'Message',
  // FILE_NAME           = 'File Name',
  // CONTACT_NAME        = 'Contact Name',
  // VENDORNAME          = 'vendorName',
  // CLASS               = 'Class',
  // WEBSITE             = 'Website',
  // FAX                 = 'Fax',
  // ACCOUNT_CLASS       ='Account Class',
  // REQUIREMENT         = 'Requirement Number',
  // VENDORTYPE          = 'Vendor Type',
  // AVL                 = 'AVL',
  // // CONTACTNAME         = 'Contact Name',
  // COMPANYRATING       = 'Company Rating',
  // DEPARTMENT          = 'Department',
  // LOCATION            = 'Location',
  // TIMEZONE            = 'Time Zone',
  // TITLE               = 'Title',
  // GENDER               = 'Gender',
  // COMPANYNAME         = 'Companny',
  // OFFICENUMBER        = 'Main Office Number + Extension',
  // DIRECTNUMBER        = 'Direct Number',
  // MOBILENUMBER        = 'Mobile Number',
  // EMAILADDRESS        = 'Email Address',
  // DONOTCALL           = 'Do Not Call',
  // DONOTEMAIL          = 'Do Not Email',
  // LASTCONTACT         = 'Last Contact',
  // NEXTTASKDUEDATE     = 'Next Task Due Date',



}
export enum PDFContactDisplayName
{
  COMPANYNAME         = 'Companny',
  COMPANY             = 'Company',
  RATING              = 'Rating',
  CONTACT_NAME        = 'Contact Name',
  DEPARTMENT          = 'Department',
  LOCATION            = 'Location',
  TIMEZONE            = 'Time Zone',
  TITLE               = 'Title',
  OFFICENUMBER        = 'Main Office Number + Extension',
  DIRECTNUMBER        = 'Direct Number',
  MOBILENUMBER        = 'Mobile Number',
  EMAILADDRESS        = 'Email Address',
  DONOTCALL           = 'Do Not Call',
  DONOTEMAIL          = 'Do Not Email',
  LASTCONTACT         = 'Last Contact',
  NEXTTASKDUEDATE     = 'Next Task Due Date',
  VENDOR_NAME         = 'Vendor Name',


}
export enum PDFVendorDisplayName{
  VENDOR_NAME         = 'Vendor Name',
  RATING              = 'Rating',
  PHONE               = 'Phone',
  Active              = 'Active',
  QUICKNOTE           = 'Quick Note',
  VENDORTYPE          = 'Vendor Type',
  AVL                 = 'AVL'
}
export enum PDFVPLDisplayName{
  MPN              = 'MPN',
  MFR              = 'Manufacturer',
  VENDOR           = 'Vendor',
  VENDOR_CONTACT   = 'Vendor Contact',
  RECORD_TYPE      = 'Record Type',
  QUANTITY         = 'Qty Available',
  EXPIRATION_DATE  = 'Expiration Date',
 // ROHS             = 'RoHS',
  CONDITION         = 'Condition',
  RATING            = 'Rating',
  ACTIVE            = 'Active',
}
export enum PDFOEMDisplayName{
  MPN              = 'MPN',
  MFR              = 'Manufacturer',
  CUSTOMER           = 'Customer',
  CUSTOMER_CONTACT   = 'Customer Contact',
  CPN              = 'CPN',
  RECORD_TYPE      = 'Record Type',
  QUANTITY         = 'Qty Available',
  EXPIRATION_DATE  = 'Expiration Date',
 // ROHS             = 'RoHS',
  CONDITION         = 'Condition',
  RATING            = 'Rating',
  ACTIVE            = 'Active',
}
export enum SiteWideColorName
{
  PRIMARY_BG_COLOR            ='primary_bg_color',
  PRIMARY_TEXT_COLOR          ="primary-text-color",
  PRIMARY_HOVER               ="primary-hover",
  SECONDARY_BG_COLOR          ='secondary_bg_color',
  SECONDARY_TEXT_COLOR        = 'secondary_text_color',
  SECONDARY_HOVER_COLOR       = 'secondary_hover_color',
  ACCENT_LINE_COLOR           = 'accent_line_color',
  DOCK_COLOR                  = 'dock_color',
  ICON_COLOR                  = 'icon_color',
  SITEWIDE_ACCENT_COLOR       = 'sitewide_accent_color',
  SITEWIDE_SECONDARY_COLOR    = 'sitewide_secondary_color',
  SITEWIDE_ACTIVE_HOVER_COLOR = 'sitewide_active_hover_color'

}

export enum OperationId{
  Status = '1',
  Rating = '2',
  LeadScore = '3',
  IntentToBuy = '4'
}

export enum CreditTerms{
    VendorTerm = 'Vendor',
    CustomerTerm = 'Customer'
}

export enum FieldTypeAndPlaceHolder{
  INPUT     = "Input",
  DROPDOWN  = "Dropdown",
  RATING    = "Rating",
  SWITCH    = "Switch",
  ENTER_COMPANY_NAME='Enter Company Name',
  ENTER_PHONE_NUMBER='Enter Phone Number'
}

export enum  DuplicateCompaniesType
{
  SYSTEMRECORD = "System Record",
  NEWRECORD = "New Record",
}

export enum  PermissonAccess {
  CAN_VIEW_BILLS= 'Accounting.Can.View.Bills',
  CAN_EDIT_BILLS= 'Accounting.Can.Edit.Bills',
  CALL_ADD_BILLS= 'Accounting.Call.Add.Bills',
  CAN_DELETE_BILLS= 'Accounting.Can.Delete.Bills',
  CAN_VIEW_CHECK= 'Accounting.Can.View.Check',
  CAN_EDIT_CHECK= 'Accounting.Can.Edit.Check',
  CAN_ADD_CHECK= 'Accounting.Can.Add.Check',
  CAN_DELETE_CHECK= 'Accounting.Can.Delete.Check',
  CAN_VIEW_CREDIT_MEMO= 'Accounting.Can.View.Credit.Memo',
  CAN_EDIT_CREDIT_MEMO= 'Accounting.Can.Edit.Credit.Memo',
  CAN_ADD_CREDIT_MEMO= 'Accounting.Can.Add.Credit.Memo',
  CAN_DELETE_CREDIT_MEMO= 'Accounting.Can.Delete.Credit.Memo',
  CAN_AUTHORIZE_CREDIT_MEMO= 'Accounting.Can.Authorize.Credit.Memo',
  CAN_POST_PAYMENT= 'Accounting.Can.Post.Payments',
  CAN_MANAGE_SETTINGS= 'Admin.Can.Manage.Settings',
  CAN_ADD_LOOKUP= 'Admin.Can.Add.Lookup',
  CAN_EDIT_LOOKUP= 'Admin.Can.Edit.Lookup',
  CAN_DELETE_LOOKUP= 'Admin.Can.Delete.Lookup',
  CAN_MANAGE_ROLES= 'Admin.Can.Manage.Roles',
  CAN_MANAGE_USERS= 'Admin.Can.Manage.Users',
  CAN_VIEW_COMPANY= 'Companies.Can.View.Company',
  CAN_VIEW_ALL_COMPANIES= 'Companies.Can.View.All.Companies',
  CAN_ADD_COMPANY= 'Companies.Can.Add.Company',
  CAN_EDIT_COMPANY= 'Companies.Can.Edit.Company',
  CAN_DELETE_COMPANY= 'Companies.Can.Delete.Company',
  CAN_AUTHORIZE_NEW_COMPANY= 'Companies.Can.Authorize.New.Company',
  CAN_PLACE_ON_CREDIT_HOLD= 'Companies.Can.Place.on.Credit.Hold',
  CAN_ADD_COMPANY_NOTE= 'Companies.Can.Add.Company.Note',
  CAN_EDIT_COMPANY_NOTE= 'Companies.Can.Edit.Company.Note',
  CAN_DELETE_COMPANY_NOTE= 'Companies.Can.Delete.Company.Note',
  CAN_PRINT_COMPANY_NOTE= 'Companies.Can.Print.Company.Note',
  CAN_VIEW_PUBLIC_ACCOUNTS= 'Companies.Can.View.Public.Accounts',
  CAN_VIEW_HOUSE_ACCOUNTS= 'Companies.Can.View.House.Accounts',
  CAN_CHANGE_HOUSE_ACCOUNT= 'Companies.Can.Change.House.Account',
  CAN_CHANGE_SALES_REP= 'Companies.Can.Change.Sales.Rep',
  CAN_VIEW_EMPLOYEES= 'Employee.Management.Can.View.Employees',
  CAN_ADD_EMPLOYEES= 'Employee.Management.Can.Add.Employees',
  CAN_EDIT_EMPLOYEES= 'Employee.Management.Can.Edit.Employees',
  CAN_DELETE_EMPLOYEES= 'Employee.Management.Can.Delete.Employees',
  CAN_VIEW_INVENTORY= 'Inventory.Management.Can.View.Inventory',
  CAN_ADD_INVENTORY= 'Inventory.Management.Can.Add.Inventory',
  CAN_EDIT_INVENTORY= 'Inventory.Management.Can.Edit.Inventory',
  CAN_DELETE_INVENTORY= 'Inventory.Management.Can.Delete.Inventory',
  CAN_UPLOAD_DATA= 'Inventory.Management.Can.Upload.Data',
  CAN_EXPORT_DATA_= 'Inventory.Management.Can.Export.Data.',
  CAN_UPLOAD_IMAGES= 'Inventory.Management.Can.Upload.Images',
  CAN_DELETE_IMAGES= 'Inventory.Management.Can.Delete.Images',
  INVENTORY_CAN_LIMIT_GL_ACCOUNTS_VIEW= 'Inventory.Management.Can.Limit.GL.Accounts.View',
  CAN_ACCESS_INVOICES= 'Invoice.Management..Can.Access.Invoices',
  CAN_ADD_INVOICES= 'Invoice.Management..Can.Add.Invoices',
  CAN_EDIT_INVOICES= 'Invoice.Management..Can.Edit.Invoices',
  CAN_VIEW_ALL_INVOICES= 'Invoice.Management..Can.View.All.Invoices',
  CAN_AUTHORIZE_INVOICES= 'Invoice.Management..Can.Authorize.Invoices',
  CAN_DELETE_INVOICES= 'Invoice.Management..Can.Delete.Invoices',
  CAN_PRINT_PICKTICKET= 'Invoice.Management..Can.Print.PickTicket',
  INVOICE_CAN_LIMIT_GL_ACCOUNTS_VIEW= 'Invoice.Management..Can.Limit.GL.Accounts.View',
  INVOICE_CAN_CREATE_CHARGE_DESCRIPTION= 'Invoice.Management..Can.Create.Charge.Description',
  ADMIN= 'Main.Page.Layout.Admin',
  ACCOUTING= 'Main.Page.Layout.Accouting',
  SALES= 'Main.Page.Layout.Sales',
  PURCHASING= 'Main.Page.Layout.Purchasing',
  CAN_ACCESS_OFFERS= 'Offers.Management.Can.Access.Offers',
  CAN_ADD_OFFERS= 'Offers.Management.Can.Add.Offers',
  CAN_EDIT_OFFERS= 'Offers.Management.Can.Edit.Offers',
  CAN_DELETE_OFFERS= 'Offers.Management.Can.Delete.Offers',
  CAN_VIEW_ALL_OFFERS= 'Offers.Management.Can.View.All.Offers',
  CAN_VIEW_PARTS= 'Parts.Management.Can.View.Parts',
  CAN_ADD_PARTS= 'Parts.Management.Can.Add.Parts',
  CAN_DELETE_PARTS= 'Parts.Management.Can.Delete.Parts',
  CAN_EDIT_PARTS= 'Parts.Management.Can.Edit.Parts',
  CAN_ACCESS_PROFORMA= 'Proforma.Management.Can.Access.Proforma',
  CAN_VIEW_ALL_PROFORMA= 'Proforma.Management.Can.View.All.Proforma',
  CAN_ADD_PROFORMA= 'Proforma.Management.Can.Add.Proforma',
  CAN_DELETE_PROFORMA= 'Proforma.Management.Can.Delete.Proforma',
  CAN_EDIT_PROFORMA= 'Proforma.Management.Can.Edit.Proforma',
  CAN_ACCESS_VIEW_POS= 'Purchasing.Management.Can.Access-View.POs',
  CAN_EDIT_POS= 'Purchasing.Management.Can.Edit.POs',
  CAN_ADD_POS= 'Purchasing.Management.Can.Add.POs',
  CAN_AUTHORIZE_POS= 'Purchasing.Management.Can.Authorize.POs',
  CAN_RECIEVE_POS= 'Purchasing.Management.Can.Recieve.POs',
  CAN_VIEW_ALL_POS= 'Purchasing.Management.Can.View.All.POs',
  CAN_DELETE_POS= 'Purchasing.Management.Can.Delete.POs',
  CAN_AUTHORIZE_PO_CHANGES= 'Purchasing.Management.Can.Authorize.PO.changes',
  PURCHASING_CAN_CREATE_CHARGE_DESCRIPTION= 'Purchasing.Management.Can.Create.Charge.Description',
  PURCHASING_CAN_LIMIT_GL_ACCOUNTS_VIEW= 'Purchasing.Management.Can.Limit.GL.Accounts.View',
  CAN_ADD_QUOTES= 'Quote.Management.Can.Add.Quotes',
  CAN_EDIT_QUOTES= 'Quote.Management.Can.Edit.Quotes',
  CAN_ACCESS_QUOTES= 'Quote.Management.Can.Access.Quotes',
  CAN_DELETE_QUOTES= 'Quote.Management.Can.Delete.Quotes',
  CAN_VIEW_ALL_QUOTE= 'Quote.Management.Can.View.All.Quote',
  CAN_VIEW_ALL_OFFER_LISTS= 'Quote.Management.Can.View.All.Offer.Lists',
  CAN_ACCESS_REPORTS= 'Reports.Can.Access.Reports',
  ACCOUNTING_REPORTS= 'Reports.Accounting.Reports',
  COMPANY_FINANCIAL= 'Reports.Company_Financial',
  CUSTOMERS_RECIEVABLE= 'Reports.Customers_Recievable',
  INVENTORY= 'Reports.Inventory',
  PURCHASE_ORDER_REPORTS= 'Reports.Purchase.Order.Reports',
  VENDORS_PAYABLES= 'Reports.Vendors_Payables',
  SALES_ORDER_REPORTS= 'Reports.Sales.Order.Reports',
  LISTINGS= 'Reports.Listings',
  CAN_ACCESS_ACTIVE_REQS= 'Requirements.Management.Can.Access.Active.Reqs',
  CAN_ADD_REQUIREMENTS= 'Requirements.Management.Can.Add.Requirements',
  CAN_EDIT_REQUIREMENTS= 'Requirements.Management.Can.Edit.Requirements',
  CAN_DELETE_REQUIREMENTS= 'Requirements.Management.Can.Delete.Requirements',
  CAN_VIEW_ALL_REQUIREMENTS= 'Requirements.Management.Can.View.All.Requirements',
  CAN_ACCESS_SOURCING_CENTER= 'Sourcing.Center.Management.Can.Access.Sourcing.Center',
  CAN_VIEW_SOURCING_CENTER= 'Sourcing.Center.Management.Can.View.Sourcing.Center',
  CAN_ADD_SOURCING_CENTER= 'Sourcing.Center.Management.Can.Add.Sourcing.Center',
  CAN_EDIT_SOURCING_CENTER= 'Sourcing.Center.Management.Can.Edit.Sourcing.Center',
  CAN_DELETE_SOURCING_CENTER= 'Sourcing.Center.Management.Can.Delete.Sourcing.Center',
  CAN_EDIT_RMAS= 'RMA.Management.Can.Edit.RMAs',
  CAN_ACCESS_RMAS= 'RMA.Management.Can.Access.RMAs',
  CAN_ADD_RMAS= 'RMA.Management.Can.Add.RMAs',
  CAN_VIEW_ALL_RMAS= 'RMA.Management.Can.View.All.RMAs',
  CAN_AUTHORIZE_RMAS= 'RMA.Management.Can.Authorize.RMAs',
  CAN_DELETE_RMAS= 'RMA.Management.Can.Delete.RMAs',
  CAN_RECIEVE_RMAS= 'RMA.Management.Can.Recieve.RMAs',
  CAN_UPLOAD_RMA_RECEIVE= 'RMA.Management.Can.Upload.RMA.Receive',
  CAN_ACCESS_SALES_ORDERS= 'Sales.Order.Management.Can.Access.Sales.Orders',
  CAN_VIEW_ALL_SALES_ORDERS= 'Sales.Order.Management.Can.View.All.Sales.Orders',
  CAN_ADD_SALES_ORDER= 'Sales.Order.Management.Can.Add.Sales.Order',
  CAN_EDIT_SALES_ORDER= 'Sales.Order.Management.Can.Edit.Sales.Order',
  CAN_AUTHORIZE_SALES_ORDERS= 'Sales.Order.Management.Can.Authorize.Sales.Orders',
  CAN_DELETE_SALES_ORDERS= 'Sales.Order.Management.Can.Delete.Sales.Orders',
  SALES_CAN_CREATE_CHARGE_DESCRIPTION= 'Sales.Order.Management.Can.Create.Charge.Description',
  CAN_LIMIT_GL_ACCOUNTS_VIEW= 'Sales.Order.Management.Can.Limit.GL.Accounts.View',
  CAN_ACCESS_WORK_ORDER= 'Work.Order.Management.Can.Access.Work.Order',
  CAN_ADD_WORK_ORDER= 'Work.Order.Management.Can.Add.Work.Order',
  CAN_AUTHORIZE_WORK_ORDERS= 'Work.Order.Management.Can.Authorize.Work.Orders',
  CAN_DELETE_WORK_ORDERS= 'Work.Order.Management.Can.Delete.Work.Orders',
  CAN_EDIT_WORK_ORDER= 'Work.Order.Management.Can.Edit.Work.Order',
  CAN_VIEW_ALL_WORK_ORDERS= 'Work.Order.Management.Can.View.All.Work.Orders',
  AUTHORIZED_NEW_COMPANY= 'Show.Messages.Authorized.New.Company',
  PART_POSTED_TO_FOUND_PART= 'Show.Messages.Part.Posted.to.Found.Part',
  AUTHORIZED_PO= 'Show.Messages.Authorized.PO',
  AUTHORIZED_SO= 'Show.Messages.Authorized.SO',
  ORDER_STATUS_NOTES_CHANGED= 'Show.Messages.Order.Status.Notes.Changed',
  RECIEVED_PO= 'Show.Messages.Recieved.PO',
  AUTHORIZED_INVOICE= 'Show.Messages.Authorized.Invoice',
  SHIPPING_CONFIRMATION_= 'Show.Messages.Shipping.Confirmation.',
  CALL_TRACKER= 'Show.Messages.Call.Tracker',
  WAREHOUSE_MESSAGE= 'Show.Messages.Warehouse.Message',
  CAN_ACCESS_SETTINGS= 'System.Access.Can.Access.Settings',
  CAN_ACCESS_VENDOR_RETURNS= 'Vender.Returns.Management.Can.Access.Vendor.Returns',
  CAN_VIEW_ALL_VENDOR_RETURNS= 'Vender.Returns.Management.Can.View.All.Vendor.Returns',
  CAN_ADD_VENDOR_RETURNS= 'Vender.Returns.Management.Can.Add.Vendor.Returns',
  CAN_CREATE_VENDOR_RETURNS= 'Vender.Returns.Management.Can.Create.Vendor.Returns',
  CAN_DELETE_VENDOR_RETURNS= 'Vender.Returns.Management.Can.Delete.Vendor.Returns',
  CAN_AUTHORIZE_VENDOR_RETURNS= 'Vender.Returns.Management.Can.Authorize.Vendor.Returns',
  CAN_EDIT_VENDOR_RETURNS= 'Vender.Returns.Management.Can.Edit.Vendor.Returns',
  CAN_ACCESS_VIEW_SHIPPING_CENTER= 'Shipping.Receiving.Management.Can.Access-View.Shipping.Center',
  CAN_MANAGE_EMAIL_TEMPLATE= 'Accounting.Can.Manage.Email.Template',
  CAN_MANAGE_TASKS= 'Task.Management.Can.Manage.Tasks',
};

export enum FilterField {
  ToDate = 'toDate',
  FromDate = 'fromDate',
  SalesPersonList = 'salesPersonList',
  AltSalesPersonList = 'altSalesPersonList',
  BuyerRepList = 'buyerRepList',
  ScopeList = 'scopeList',
  TimeZoneList = 'timeZoneList',
  LeadScoreList = 'leadScoreList',
  ProspectScoreList = 'prospectScoreList',
  NaicsCodeList = 'naicsCodeList',
  CountryList = 'countryList',
  StateList = 'stateList',
  ClassList = 'classList',
  VendorTypeList = 'vendorTypeList',
  TagsList = 'tagsList',
  StartRating = 'startRating',
  StageStatusList = 'stageStatusList',
  EndRating = 'endRating',
  Archived = 'archived',
  AvlId = 'avlId',
  SicCodeList = 'sicCodeList',
  ExcludedFromVendorlist = 'excludedFromVendorlist',
  IndustryList = 'industryList',
  CompanyStatusId = 'companyStatusId',
  ManufacturerList = 'manufacturerList',
  PartTagsList = 'partTagsList',
  CategoryGroupList = 'categoryGroupList',
  ParentCategoryGroupList = 'parentCategoryGroupList',
  InventoryCategoryList = 'inventoryCategoryList',
  SubCategoryList = 'subCategoryList',
  PartStatusList = 'partStatusList',
  CustomerCompanyNameList = 'customerCompanyNameList',
  ContactNameList = 'contactNameList',
  VendorNameList = 'vendorNameList',
  VendorContactList = 'vendorContactList',
  RequirementStatusList = 'requirementStatusList',
  OpportunityTypeList = 'opportunityTypeList',
  OpportunityBuyTypeList = 'opportunityBuyTypeList',
  PriorityList = 'priorityList'
}

export enum DocumentTypes
{
    companyDocuments = 1,
    tradeReferenceDocument = 2,
    resellerDocument = 3,
    certificationDocument = 4,
    partInventory = 5,
    partConsignment = 6,
}


export class HubConstant {
  public static readonly CompanyCreatedFunction               = "company.created";
  public static readonly CompanyUpdatedFunction               = "company.updated";
  public static readonly VendorCreatedFunction                = "vendor.created";
  public static readonly VendorUpdatedFunction                = "vendor.updated";
  public static readonly UserCreatedFunction                  = "user.created";
  public static readonly UserUpdatedFunction                  = "user.updated";
  public static readonly PartsCreatedFunction                = "parts.created";
  public static readonly PartsUpdatedFunction                = "parts.updated";
  public static readonly ContactCreatedFunction              = "contact.created";
  public static readonly ContactUpdatedFunction              = "contact.updated";
  public static readonly VendorContactCreatedFunction        = "vendor contact.created";
  public static readonly VendorContactUpdatedFunction        = "vendor contact.updated";
  public static readonly ActivityCreatedFunction             = "activity.created";
  public static readonly ActivityUpdatedFunction             = "activity.updated";
  public static readonly UserRoleCreatedFunction             = "userrole.created";
  public static readonly UserRoleUpdatedFunction             = "userrole.updated";
  public static readonly CodeCrosswalkCreatedFunction        = "codecrosswalk.created";
  public static readonly CodeCrosswalkUpdatedFunction        = "codecrosswalk.updated";
  public static readonly CodeCrosswalkDeletedFunction        = "codecrosswalk.deleted";
  public static readonly CompanyDeletedFunction             = "company.deleted";
  public static readonly ContactDeletedFunction             = "contact.deleted";
  public static readonly PartsDeletedFunction               = "parts.deleted";
  public static readonly vendorDeletedFunction              = "vendor.deleted";
  public static readonly VendorContactDeletedFunction       = "vendor contact.deleted";
  public static readonly LeadCreatedFunction                = "lead.created";
  public static readonly LeadUpdatedFunction                = "lead.updated";
  public static readonly ProspectCreatedFunction            = "prospect.created";
  public static readonly ProspectUpdatedFunction            = "prospect.updated";
  public static readonly CustomerCreatedFunction            = "customer.created";
  public static readonly CustomerUpdatedFunction            = "customer.updated";
  public static readonly LeadDeletedFunction                = "lead.deleted";
  public static readonly ProspectDeletedFunction            = "prospect.deleted";
  public static readonly CustomerDeletedFunction            = "customer.deleted";
  public static readonly CompanyDetailsFunction             = "companydetails.added";
  public static readonly PartsDetailsFunction               = "partsdetails.added";
  public static readonly UserDeletedFunction                = "user.deleted";
  }
  
  export enum StatusChange {
    CompanyCreated = 1,
    CompanyUpdated = 2,
    VendorCreated = 3,
    VendorUpdated = 4,
    UserCreated = 5,
    UserUpdated = 6,
    PartsCreated = 7,
    PartsUpdated  = 8,
    ContactCreated = 9,
    ContactUpdated  = 10,
    VendorContactCreated = 11,
    VendorContactUpdated  = 12,
    ActivityCreated = 13,
    ActivityUpdated  = 14,
    UserRoleCreated = 15,
    UserRoleUpdated  = 16,
     CodeCrosswalkCreated = 17,
     CodeCrosswalkUpdated  = 18,
     CodeCrosswalkDeleted  = 19,
    CompanyDeleted  = 20,
    ContactDeleted  = 21, 
    PartsDeleted = 23,
    //its a dummy
    VendorDeleted  = 24,
    VendorContactDeleted  = 25,
    LeadCreated = 26,
    LeadUpdated = 27,
    ProspectCreated = 28,
    ProspectUpdated = 29,
    CustomerCreated = 30,
    CustomerUpdated = 31,
    LeadDeleted  = 32,
    ProspectDeleted  = 33, 
    CustomerDeleted = 34,
    CompanyDetails = 35,
    PartsDetails = 36,
    UserDeleted = 37,
  }
  
   
export enum TraceLabel
{
FullManufacturerLabel = 1,
RedactedManufacturerLabel = 2,
NoManufacturerLabel = 3
}
export enum TraceDocument
{
ManufacturerCoc = 1,
FranchiseCoc = 2,
ThirdPartyFranchise = 3
}
export enum PartType
{
PartInventory = 1,
PartConsignment = 2
}
export enum ImportTemplateSource{
  Companies     = 1,
  Vendor        = 2,
  CodeCrosswalk = 3,
  Parts         = 4,
  Inventory     = 5,
  Consignment   = 6,
  VendorParts   = 7,
  OEMExcess     = 8,
  Requirement   = 9,
  Offer         = 10
}
export enum ImportTemplateFileName{
  IMPORT_PART = 'SamplePartImport',
  IMPORT_INVENTORY = 'SamplePartInventory',
  IMPORT_OEMEXCESS = 'SampleOEMExcessImport',
  IMPORT_VENDOR_PART = 'SampleVendorTemplate',
  IMPORT_CONSIGNMENT = 'SamplePartConsignment',
}
export enum VplOemId{
  VPL = 1,
  OEM = 2,
}

export enum ExpireStatus{
  ACTIVE_LINES ='active lines',
  INACTIVE_LINES = 'inactive lines',
  ACTIVE_VENDOR_PARTS = 'active vendor parts',
  EXPIRE_VENDOR_PARTS ='expired vendor parts'
}

export enum RequirementStatusEnum {
  DRAFT = 'Draft',
  NEW = 'New',
  SOURCING = 'Sourcing',
  SOURCED_READY = 'Sourced/Ready',
  NO_BID = 'No Bid',
  QUOTED = 'Quoted',
  SOLD= 'Sold',
  LOST = 'Lost',
  CANCELLED = 'Cancelled',
}

export enum RFQsSentMenuActionEnum {
  ADD_OFFER = 'ADD_OFFER',
  ADD_ALTERNATE_OFFER = 'ADD_ALTERNATE_OFFER',
  MARK_NA = 'MARK_NA',
  NO_BID = 'NO_BID',
}
export enum RFQsSentMenuLabelEnum {
  ADD_OFFER = 'Add Offer',
  ADD_ALTERNATE_OFFER = 'Add Alternate Offer',
  MARK_NA = 'Mark N/A',
  NO_BID = 'No Bid',
}
export enum SourcingStepEnum {
  FIND_SOURCES = 'Find Sources',
  SEND_RFQS = 'Send RFQs',
  VIEW_APPROVE_SOURCES = 'View & Approve Sources',
  FINALIZE_SOURCES = 'Finalize Sources',
}
export enum LineStatusEnumLabel {
  MARK_NO_BID = 'Mark No Bid',
  MARK_READY = 'Mark Ready',
}
export enum LineStatusEnumAction {
  MARK_READY = 'MARK_READY',
  MARK_NO_BID = 'MARK_NO_BID',
}
export enum StatusOptions{
  ALL = 'All',
  OPEN  ='Open',
  CLOSED  = 'Closed',
}
export enum SourcesTypesEnum{
  ONHAND  = 'On Hand',
  OFFERS = 'Offers',
  ON_ORDER = 'On Order',
  CONSIGNMENT = "Consignment",
}
